module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('my-logo', {
    attrs: {
      "title": _vm.title
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "点击修改标题"
    },
    on: {
      "click": _vm.change_title
    }
  }), _c('br'), _vm._v(" "), _c('table', _vm._l((_vm.blogs), function(blog) {
    return _c('tr', [_c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'Blog',
          query: {
            id: blog.id
          }
        }
      }
    }, [_vm._v("\n          " + _vm._s(blog.id) + "\n        ")])], 1), _vm._v(" "), _c('td', {
      on: {
        "click": function($event) {
          _vm.show_blog(blog.id)
        }
      }
    }, [_vm._v(_vm._s(blog.title))])])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d36bcb62"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlogList.vue
// module id = 72
// module chunks = 0